/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { useEffect } from "react";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Loader from "components/Loader";

// Settings page components
import BaseLayout from "layouts/pages/account/components/BaseLayout";
import Sidenav from "layouts/pages/account/allProfiles/components/Sidenav";
import Header from "layouts/pages/account/allProfiles/components/Header";
import Authentication from "layouts/pages/account/allProfiles/components/Authentication";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/profile";
import * as actionTypes from "redux/constants";

function Settings() {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(actions.getAllProfiles());
  }, [dispatch]);

  if (profile.loading) {
    return <Loader />;
  } else {
    return (
      <BaseLayout>
        <MDBox mt={4}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={3}>
              <Sidenav />
            </Grid>
            <Grid item xs={12} lg={9}>
              <MDBox mb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Header userName={profile.profileInfo?.userName} />
                  </Grid>
                  <Grid item xs={12}>
                    <Authentication
                      orgs={profile.allProfiles.orgs}
                      doctors={profile.allProfiles.doctors}
                      patients={profile.allProfiles.patients}
                      feedbacks={profile.allProfiles.feedbacks}
                      role={auth.user?.role}
                      actionTypes={actionTypes}
                    />
                  </Grid>
                </Grid>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </BaseLayout>
    );
  }
}

export default Settings;
